import type { DiaEspecial } from '../../../api/ops/disponibilidad';
import type { Recolocacion } from '../../../api/ops/servicios';
import type { EstadoChip } from '../../../componentes/Chip';
import { fechaLarga, rangoDeTramo, type Rango } from '../../../logica/horario';
import { hm, mayuscula } from '../../agenda/logica';

/** Estado de una cita afectada (para quien no la puede resolver). */
export const ESTADO_RECOLOCACION: Readonly<Record<Recolocacion['status'], { texto: string; chip: EstadoChip }>> = {
    pending: { texto: 'Por resolver', chip: 'pending' },
    needs_customer: { texto: 'Hablar con el cliente', chip: 'pending' },
    relocated: { texto: 'Recolocada', chip: 'confirmed' },
    moved: { texto: 'Movida', chip: 'confirmed' },
    kept: { texto: 'Se mantiene', chip: 'neutral' },
    cancelled: { texto: 'Cancelada', chip: 'problem' },
};

/** Por qué quedó fuera. El cierre del negocio no sale en el diseño: se dice igual que los demás. */
export const POR_QUE: Readonly<Record<Recolocacion['cause'], string>> = {
    exception: 'por un día especial',
    schedule_change: 'por un cambio de horario',
    professional_deactivated: 'por una baja',
    closure: 'por un cierre',
};

export const textoTramos = (tramos: readonly Rango[]): string => tramos.map((r) => `${hm(r.desde)} – ${hm(r.hasta)}`).join(' y ');

/** La fila de un día especial: título (su motivo), cuándo con sus tramos y su chip. */
export function lineaDiaEspecial(d: DiaEspecial, anio: number): { titulo: string; sub: string; chip: string } {
    const cerrado = d.kind !== 'special_hours';
    const titulo = d.reason !== undefined && d.reason.trim() !== '' ? d.reason : cerrado ? 'No trabaja' : 'Horario especial';
    const cuando = d.start_date === d.end_date ? mayuscula(fechaLarga(d.start_date, anio)) : `Del ${fechaLarga(d.start_date, anio)} al ${fechaLarga(d.end_date, anio)}`;
    const tramos = cerrado ? '' : ` · ${textoTramos((d.intervals ?? []).map(rangoDeTramo))}`;
    return { titulo, sub: `${cuando}${tramos}`, chip: cerrado ? 'No trabaja' : 'Horario especial' };
}
